import { createUnauthorizedCall } from '../../store/utils';
import * as actionTypes from './action-types';

export const getEnableOnlineAuction = () => createUnauthorizedCall(
    { fetch: actionTypes.GET_ENABLE_ONLINE_AUCTION, loading: actionTypes.LOADING_FEATURE_FLAGS },
    api => api.featureFlags.getEnableOnlineAuction)();
